import { HttpError, useList } from "@refinedev/core";
import { ITruck } from "interfaces";
import { useEffect, useState } from "react";

interface IUseGetTrucksProps {
    enabled?: boolean;
}

export const useGetTrucks = ({ enabled }: IUseGetTrucksProps) => {
    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isError, setIsError] = useState<boolean>(false);
    const {
        data: responseData,
        isLoading: responseIsLoading,
        isError: responseIsError,
    } = useList<ITruck, HttpError>({
        resource: "trucks",
        filters: [
            {
                field: "is_available",
                operator: "eq",
                value: "true",
            },
        ],
        queryOptions: {
            enabled,
        },
    });

    useEffect(() => {
        if (responseData?.data && !responseIsLoading) {
            setData(responseData.data);
            setIsLoading(responseIsLoading);
            setIsError(responseIsError);
        }
    }, [responseData, responseIsLoading, responseIsError]);

    return {
        data,
        isLoading,
        isError,
    };
};